import { render, staticRenderFns } from "./SorteosOptionsNewOrEdit.vue?vue&type=template&id=682b6606"
import script from "./SorteosOptionsNewOrEdit.vue?vue&type=script&lang=js"
export * from "./SorteosOptionsNewOrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports